'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var hexToRgb = require('./hexToRgb-7c8edffc.js');
var pill = require('./pill-89b3b361.js');
require('./enums-de2d9d36.js');

var statusVariants = {
    danger: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.pink;
    }),
    primary: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }),
    secondary: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.secondary;
    }),
    success: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.green;
    }),
    warning: styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.orange;
    }),
    dark: styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }),
    light: styled.css(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMedium;
    }),
    orange: styled.css(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.palette.systemOrange;
    }),
    green: styled.css(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.palette.systemGreen;
    }),
    blue: styled.css(templateObject_10 || (templateObject_10 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.palette.systemPurple;
    }),
};
var statusVariantsV2 = {
    danger: styled.css(templateObject_11 || (templateObject_11 = tslib_es6.__makeTemplateObject(["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "], ["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "])), function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = hexToRgb.hexToRgb(theme.colors.admin.pink)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.pink;
    }),
    primary: styled.css(templateObject_12 || (templateObject_12 = tslib_es6.__makeTemplateObject(["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "], ["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "])), function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = hexToRgb.hexToRgb(theme.colors.primary)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }),
    secondary: styled.css(templateObject_13 || (templateObject_13 = tslib_es6.__makeTemplateObject(["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "], ["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "])), function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = hexToRgb.hexToRgb(theme.colors.secondary)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.secondary;
    }),
    success: styled.css(templateObject_14 || (templateObject_14 = tslib_es6.__makeTemplateObject(["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "], ["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "])), function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = hexToRgb.hexToRgb(theme.colors.admin.green)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.green;
    }),
    warning: styled.css(templateObject_15 || (templateObject_15 = tslib_es6.__makeTemplateObject(["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "], ["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "])), function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = hexToRgb.hexToRgb(theme.colors.admin.orange)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.orange;
    }),
    dark: styled.css(templateObject_16 || (templateObject_16 = tslib_es6.__makeTemplateObject(["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "], ["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "])), function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = hexToRgb.hexToRgb(theme.colors.greys.adminGreyDark)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }),
    light: styled.css(templateObject_17 || (templateObject_17 = tslib_es6.__makeTemplateObject(["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "], ["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "])), function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = hexToRgb.hexToRgb(theme.colors.greys.adminGreyMedium)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMedium;
    }),
    orange: styled.css(templateObject_18 || (templateObject_18 = tslib_es6.__makeTemplateObject(["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "], ["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "])), function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = hexToRgb.hexToRgb(theme.colors.palette.systemOrange)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.palette.systemOrange;
    }),
    green: styled.css(templateObject_19 || (templateObject_19 = tslib_es6.__makeTemplateObject(["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "], ["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "])), function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = hexToRgb.hexToRgb(theme.colors.palette.systemGreen)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.palette.systemGreen;
    }),
    blue: styled.css(templateObject_20 || (templateObject_20 = tslib_es6.__makeTemplateObject(["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "], ["\n    background-color: rgba(", ", .1);\n    color: ", "\n  "])), function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = hexToRgb.hexToRgb(theme.colors.palette.systemPurple)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.palette.systemPurple;
    }),
};
var Container = styled__default.div(templateObject_21 || (templateObject_21 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  align-items: center;\n  overflow: hidden;\n  ", "\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  align-items: center;\n  overflow: hidden;\n  ",
    "\n"])), function (_a) {
    var isHqOTableCell = _a.isHqOTableCell;
    return isHqOTableCell && ("\n    padding: 12px 16px;\n    border: 1px solid transparent;\n  ");
});
var Indicator = styled__default.span(templateObject_22 || (templateObject_22 = tslib_es6.__makeTemplateObject(["\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    margin-right: 8px;\n    flex-shrink: 0;\n    ", ";\n"], ["\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    margin-right: 8px;\n    flex-shrink: 0;\n    ", ";\n"])), function (_a) {
    var circleColor = _a.circleColor, variant = _a.variant;
    return (circleColor ? "background-color: " + circleColor : statusVariants[variant]);
});
var Text = styled__default.span(templateObject_23 || (templateObject_23 = tslib_es6.__makeTemplateObject(["\n  font: normal 14px/22px ", ";\n  color: ", ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"], ["\n  font: normal 14px/22px ", ";\n  color: ", ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var StyledPill = styled__default(pill.Pill)(templateObject_24 || (templateObject_24 = tslib_es6.__makeTemplateObject(["\n  font-size: 12px;\n  line-height: 15px;\n\n  ", ";\n\n  &:hover {\n    ", ";\n"], ["\n  font-size: 12px;\n  line-height: 15px;\n\n  ",
    ";\n\n  &:hover {\n    ",
    ";\n"])), function (_a) {
    var _b;
    var indicatorColor = _a.indicatorColor, indicatorVariant = _a.indicatorVariant;
    return (indicatorColor ? "\n    background-color: rgba(" + ((_b = hexToRgb.hexToRgb(indicatorColor)) === null || _b === void 0 ? void 0 : _b.join(',')) + ", .1);\n    color: " + indicatorColor + "\n  " : indicatorVariant && statusVariantsV2[indicatorVariant]);
}, function (_a) {
    var _b;
    var indicatorColor = _a.indicatorColor, indicatorVariant = _a.indicatorVariant;
    return (indicatorColor ? "\n    background-color: rgba(" + ((_b = hexToRgb.hexToRgb(indicatorColor)) === null || _b === void 0 ? void 0 : _b.join(',')) + ", .1);\n    color: " + indicatorColor + "\n  " : indicatorVariant && statusVariantsV2[indicatorVariant]);
});
var StatusIndicator = function (_a) {
    var color = _a.color, label = _a.label, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, _c = _a.isHqOTableCell, isHqOTableCell = _c === void 0 ? false : _c, _d = _a.version, version = _d === void 0 ? 1 : _d, rest = tslib_es6.__rest(_a, ["color", "label", "variant", "isHqOTableCell", "version"]);
    if (version === 2) {
        return (React__default.createElement(Container, tslib_es6.__assign({ isHqOTableCell: isHqOTableCell }, rest),
            React__default.createElement(StyledPill, { dataTestId: "status-pill", indicatorColor: color, indicatorVariant: variant }, label)));
    }
    return (React__default.createElement(Container, tslib_es6.__assign({ isHqOTableCell: isHqOTableCell }, rest),
        React__default.createElement(Indicator, { "data-testid": "status-color", circleColor: color, variant: variant }),
        React__default.createElement(Text, { "data-testid": "status-text" }, label)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;

exports.Indicator = Indicator;
exports.StatusIndicator = StatusIndicator;
